import React from "react";
import styles from "./normal.module.css";

export const LightText = ({ children, align="left",size }) => {
  return <div style={{textAlign:align,fontSize:size}} className={`${styles.text}`}>{children}</div>;
};
